let __flarum_default_export__;
import PrivateDiscussionsPage from './PrivateDiscussionsPage';
export default __flarum_default_export__ = () => {
  PrivateDiscussionsPage();
};
flarum.reg.add('fof-byobu', 'forum/pages', __flarum_default_export__);